export const apiBaseUri = process.env.REACT_APP_ADMIN_API_BASE_URL || "";
export const serverName = process.env.REACT_APP_SERVER_NAME || "";

export const svgStateDeselectedColor = "#bbb";
export const svgStateSelectedColor = "#222";

export const colorLimitReached = "#28CC2E";
export const colorOverHalfwayReached = "#FAA93F";
export const colorBelowHalfwayReached = "#FA4C3F";

export const projectStartDate = "2024-12-01T00:00:00";
export const allCourseIds = [
  process.env.REACT_APP_ST_BC_ADVANCE_COURSE_ID,
  process.env.REACT_APP_ST_BC_BASIC_COURSE_ID,
  process.env.REACT_APP_ST_DRA_GRADUATE_COURSE_ID,
  process.env.REACT_APP_ST_DRA_UNDER_GRADUATE_COURSE_ID,
];
export const draCourseIds = [
  process.env.REACT_APP_ST_DRA_GRADUATE_COURSE_ID,
  process.env.REACT_APP_ST_DRA_UNDER_GRADUATE_COURSE_ID,
];
export const bcbfCourseIds = [
  process.env.REACT_APP_ST_BC_ADVANCE_COURSE_ID,
  process.env.REACT_APP_ST_BC_BASIC_COURSE_ID,
];
